module.exports = __webpack_public_path__ + "media/images/sp/specials/common/event_detail_dress-632f6a274b6abcb00f37c0036fada9a6.jpg";